// @flow
import { filter, find, uniq } from 'lodash';
import { StringUtil } from 'utils/StringUtil';
import { NumberUtil } from 'utils/NumberUtil';
import { ProductSelector } from 'modules/product/selector';
import type { ProductFilters } from 'types/filter';

const transformProductDetails = response => {
  const responseData = response.data.data;
  let productDetails = [];
  const path = responseData && responseData.media_path;
  const web = responseData && responseData.device.web;
  const mobile = responseData && responseData.device.mobile;
  const thumbnail = responseData && responseData.device.thumbnail;

  responseData.products_details.forEach(data => {
    const details = {
      id: data.id,
      url_slug: data.url_slug,
      product_name: data.product_name,
      productVersion: data.product_version !== null ? data.product_version : '',
      image: data.product_detail_image,
      mobile_image: data.detail_mobile_image,
      min_area: NumberUtil.formatNumber(data.min_area),
      max_area: NumberUtil.formatNumber(data.max_area),
      short_content: data.short_content,
      long_content: data.long_content,
      description_mobile: data.short_mobile_content,
      productBrochureUrl: `https://carmatec.blob.core.windows.net/te-products/Files/${data.product_brochure}`,
      productBrochure: data.product_brochure,
      brochure_campaign_code: data.brochure_campaign_code,
      virtualTours: (data.product_degreeviews || []).map(tour => {
        return {
          id: tour.id,
          view: tour.degree360_view,
        };
      }),
      metaTagSEO: {
        metaTitle: data.meta_title ? data.meta_title : '',
        metaDescription: data.meta_description ? data.meta_description : '',
        metaKeywords: data.meta_keyword ? data.meta_keyword : '',
      },
      banner_video: data.header_video,
    };
    productDetails.push(details);
  });
  return {
    productDetails,
    path: path,
    web: web,
    mobile: mobile,
    thumbnail: thumbnail,
  };
};

const order = (a, b) => {
  return a.detailCard.productName.localeCompare(b.detailCard.productName);
};

const formatProducts = data => {
  let productBrowserData = [];
  const image_path = data.data.data.media_path;
  const device = data.data.data.device;
  let productBrowserArray = data.data.data.products
    ? data.data.data.products
    : '';
  productBrowserArray.forEach(product => {
    const transformedData = {
      device,
      mediaPath: image_path,
      detailCard: {
        id: product.id,
        max_area: NumberUtil.formatNumber(product.max_area),
        min_area: NumberUtil.formatNumber(product.min_area),
        bathrooms: product.number_of_bathrooms,
        bedrooms: product.number_of_bedrooms,
        productName: product.product_name,
        productVersion:
          product.product_version !== null ? product.product_version : '',
        url_slug: product.url_slug,
        images: {
          image_path,
          image: product.product_list_image1,
          hover_image: product.product_list_image2,
          mobile_image: product.list_mobile_image1,
        },
        content: StringUtil.sliceHtml(product.short_content),
        propertyType: product.property_type_id,
        projects: (product.properties || []).map(property => {
          return {
            id: property.project_id,
            cityId: property.project.city_id,
          };
        }),
      },
    };
    productBrowserData.push(transformedData);
  });

  return productBrowserData.sort(order);
};

const displayProductsInProductBrowser = state => {
  const allProducts = state.productBrowser.products;
  const currentProductDetail = state.productBrowser.productDetails;

  if (allProducts && currentProductDetail) {
    const currentProductSLug = currentProductDetail.productDetails[0].url_slug;
    return filter(allProducts, function(n) {
      return currentProductSLug !== n.detailCard.url_slug;
    });
  }
  return [];
};

export const ProductTransformations = {
  transformProductDetails,
  formatProducts,
  displayProductsInProductBrowser,
};
